/**
 * Worldwide timezone configuration for frontend
 * Organized by geographical regions for better user experience
 */

export const WORLDWIDE_TIMEZONES = [
  {
    region: 'UTC',
    timezones: [
      { value: 'UTC', label: 'UTC (UTC+0)', description: 'Coordinated Universal Time' }
    ]
  },
  {
    region: 'North America',
    timezones: [
      // Eastern
      { value: 'America/New_York', label: 'New York (UTC-5/-4)', description: 'Eastern Standard/Daylight Time' },
      { value: 'America/Toronto', label: 'Toronto (UTC-5/-4)', description: 'Eastern Standard/Daylight Time' },
      { value: 'America/Detroit', label: 'Detroit (UTC-5/-4)', description: 'Eastern Standard/Daylight Time' },
      { value: 'America/Montreal', label: 'Montreal (UTC-5/-4)', description: 'Eastern Standard/Daylight Time' },
      { value: 'America/Miami', label: 'Miami (UTC-5/-4)', description: 'Eastern Standard/Daylight Time' },
      { value: 'America/Atlanta', label: 'Atlanta (UTC-5/-4)', description: 'Eastern Standard/Daylight Time' },
      
      // Central
      { value: 'America/Chicago', label: 'Chicago (UTC-6/-5)', description: 'Central Standard/Daylight Time' },
      { value: 'America/Winnipeg', label: 'Winnipeg (UTC-6/-5)', description: 'Central Standard/Daylight Time' },
      { value: 'America/Mexico_City', label: 'Mexico City (UTC-6/-5)', description: 'Central Standard Time' },
      { value: 'America/Guatemala', label: 'Guatemala (UTC-6)', description: 'Central Standard Time' },
      { value: 'America/Dallas', label: 'Dallas (UTC-6/-5)', description: 'Central Standard/Daylight Time' },
      
      // Mountain
      { value: 'America/Denver', label: 'Denver (UTC-7/-6)', description: 'Mountain Standard/Daylight Time' },
      { value: 'America/Edmonton', label: 'Edmonton (UTC-7/-6)', description: 'Mountain Standard/Daylight Time' },
      { value: 'America/Phoenix', label: 'Phoenix (UTC-7)', description: 'Mountain Standard Time (no DST)' },
      { value: 'America/Salt_Lake_City', label: 'Salt Lake City (UTC-7/-6)', description: 'Mountain Standard/Daylight Time' },
      
      // Pacific
      { value: 'America/Los_Angeles', label: 'Los Angeles (UTC-8/-7)', description: 'Pacific Standard/Daylight Time' },
      { value: 'America/Vancouver', label: 'Vancouver (UTC-8/-7)', description: 'Pacific Standard/Daylight Time' },
      { value: 'America/Seattle', label: 'Seattle (UTC-8/-7)', description: 'Pacific Standard/Daylight Time' },
      { value: 'America/San_Francisco', label: 'San Francisco (UTC-8/-7)', description: 'Pacific Standard/Daylight Time' },
      
      // Other North America
      { value: 'America/Anchorage', label: 'Anchorage (UTC-9/-8)', description: 'Alaska Standard/Daylight Time' },
      { value: 'Pacific/Honolulu', label: 'Honolulu (UTC-10)', description: 'Hawaii Standard Time' },
      { value: 'America/St_Johns', label: 'St. Johns (UTC-3:30/-2:30)', description: 'Newfoundland Standard/Daylight Time' }
    ]
  },
  {
    region: 'South America',
    timezones: [
      { value: 'America/Sao_Paulo', label: 'São Paulo (UTC-3/-2)', description: 'Brasilia Standard/Summer Time' },
      { value: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires (UTC-3)', description: 'Argentina Time' },
      { value: 'America/Lima', label: 'Lima (UTC-5)', description: 'Peru Time' },
      { value: 'America/Bogota', label: 'Bogotá (UTC-5)', description: 'Colombia Time' },
      { value: 'America/Santiago', label: 'Santiago (UTC-4/-3)', description: 'Chile Standard/Summer Time' },
      { value: 'America/Caracas', label: 'Caracas (UTC-4)', description: 'Venezuela Time' },
      { value: 'America/La_Paz', label: 'La Paz (UTC-4)', description: 'Bolivia Time' },
      { value: 'America/Montevideo', label: 'Montevideo (UTC-3)', description: 'Uruguay Standard Time' }
    ]
  },
  {
    region: 'Europe',
    timezones: [
      // Western Europe
      { value: 'Europe/London', label: 'London (UTC+0/+1)', description: 'Greenwich Mean Time / British Summer Time' },
      { value: 'Europe/Dublin', label: 'Dublin (UTC+0/+1)', description: 'Irish Standard Time' },
      { value: 'Europe/Lisbon', label: 'Lisbon (UTC+0/+1)', description: 'Western European Time' },
      
      // Central Europe
      { value: 'Europe/Berlin', label: 'Berlin (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Paris', label: 'Paris (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Rome', label: 'Rome (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Madrid', label: 'Madrid (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Amsterdam', label: 'Amsterdam (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Zurich', label: 'Zurich (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Vienna', label: 'Vienna (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Prague', label: 'Prague (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Warsaw', label: 'Warsaw (UTC+1/+2)', description: 'Central European Time' },
      { value: 'Europe/Stockholm', label: 'Stockholm (UTC+1/+2)', description: 'Central European Time' },
      
      // Eastern Europe
      { value: 'Europe/Helsinki', label: 'Helsinki (UTC+2/+3)', description: 'Eastern European Time' },
      { value: 'Europe/Athens', label: 'Athens (UTC+2/+3)', description: 'Eastern European Time' },
      { value: 'Europe/Bucharest', label: 'Bucharest (UTC+2/+3)', description: 'Eastern European Time' },
      { value: 'Europe/Kiev', label: 'Kiev (UTC+2/+3)', description: 'Eastern European Time' },
      { value: 'Europe/Sofia', label: 'Sofia (UTC+2/+3)', description: 'Eastern European Time' },
      
      // Other Europe
      { value: 'Europe/Moscow', label: 'Moscow (UTC+3)', description: 'Moscow Standard Time' },
      { value: 'Europe/Istanbul', label: 'Istanbul (UTC+3)', description: 'Turkey Time' }
    ]
  },
  {
    region: 'Asia',
    timezones: [
      // East Asia
      { value: 'Asia/Tokyo', label: 'Tokyo (UTC+9)', description: 'Japan Standard Time' },
      { value: 'Asia/Seoul', label: 'Seoul (UTC+9)', description: 'Korea Standard Time' },
      { value: 'Asia/Shanghai', label: 'Shanghai (UTC+8)', description: 'China Standard Time' },
      { value: 'Asia/Hong_Kong', label: 'Hong Kong (UTC+8)', description: 'Hong Kong Time' },
      { value: 'Asia/Taipei', label: 'Taipei (UTC+8)', description: 'Taipei Standard Time' },
      { value: 'Asia/Macau', label: 'Macau (UTC+8)', description: 'China Standard Time' },
      
      // Southeast Asia
      { value: 'Asia/Bangkok', label: 'Bangkok (UTC+7)', description: 'Indochina Time' },
      { value: 'Asia/Jakarta', label: 'Jakarta (UTC+7)', description: 'Western Indonesia Time' },
      { value: 'Asia/Kuala_Lumpur', label: 'Kuala Lumpur (UTC+8)', description: 'Malaysia Time' },
      { value: 'Asia/Manila', label: 'Manila (UTC+8)', description: 'Philippine Standard Time' },
      { value: 'Asia/Singapore', label: 'Singapore (UTC+8)', description: 'Singapore Standard Time' },
      { value: 'Asia/Ho_Chi_Minh', label: 'Ho Chi Minh City (UTC+7)', description: 'Indochina Time' },
      { value: 'Asia/Yangon', label: 'Yangon (UTC+6:30)', description: 'Myanmar Time' },
      
      // South Asia
      { value: 'Asia/Kolkata', label: 'Mumbai/Delhi (UTC+5:30)', description: 'India Standard Time' },
      { value: 'Asia/Dhaka', label: 'Dhaka (UTC+6)', description: 'Bangladesh Standard Time' },
      { value: 'Asia/Karachi', label: 'Karachi (UTC+5)', description: 'Pakistan Standard Time' },
      { value: 'Asia/Colombo', label: 'Colombo (UTC+5:30)', description: 'Sri Lanka Standard Time' },
      { value: 'Asia/Kathmandu', label: 'Kathmandu (UTC+5:45)', description: 'Nepal Time' },
      
      // Central Asia
      { value: 'Asia/Tashkent', label: 'Tashkent (UTC+5)', description: 'Uzbekistan Time' },
      { value: 'Asia/Almaty', label: 'Almaty (UTC+6)', description: 'Kazakhstan Time' },
      
      // West Asia / Middle East
      { value: 'Asia/Dubai', label: 'Dubai (UTC+4)', description: 'Gulf Standard Time' },
      { value: 'Asia/Qatar', label: 'Doha (UTC+3)', description: 'Arabia Standard Time' },
      { value: 'Asia/Kuwait', label: 'Kuwait (UTC+3)', description: 'Arabia Standard Time' },
      { value: 'Asia/Riyadh', label: 'Riyadh (UTC+3)', description: 'Arabia Standard Time' },
      { value: 'Asia/Tehran', label: 'Tehran (UTC+3:30/+4:30)', description: 'Iran Standard/Daylight Time' },
      { value: 'Asia/Jerusalem', label: 'Jerusalem (UTC+2/+3)', description: 'Israel Standard/Daylight Time' },
      { value: 'Asia/Baghdad', label: 'Baghdad (UTC+3)', description: 'Arabia Standard Time' }
    ]
  },
  {
    region: 'Africa',
    timezones: [
      { value: 'Africa/Cairo', label: 'Cairo (UTC+2)', description: 'Egypt Standard Time' },
      { value: 'Africa/Lagos', label: 'Lagos (UTC+1)', description: 'West Africa Time' },
      { value: 'Africa/Johannesburg', label: 'Johannesburg (UTC+2)', description: 'South Africa Standard Time' },
      { value: 'Africa/Nairobi', label: 'Nairobi (UTC+3)', description: 'East Africa Time' },
      { value: 'Africa/Casablanca', label: 'Casablanca (UTC+0/+1)', description: 'Western European Time' },
      { value: 'Africa/Tunis', label: 'Tunis (UTC+1)', description: 'Central European Time' },
      { value: 'Africa/Addis_Ababa', label: 'Addis Ababa (UTC+3)', description: 'East Africa Time' },
      { value: 'Africa/Accra', label: 'Accra (UTC+0)', description: 'Greenwich Mean Time' }
    ]
  },
  {
    region: 'Australia & Oceania',
    timezones: [
      { value: 'Australia/Sydney', label: 'Sydney (UTC+10/+11)', description: 'Australian Eastern Time' },
      { value: 'Australia/Melbourne', label: 'Melbourne (UTC+10/+11)', description: 'Australian Eastern Time' },
      { value: 'Australia/Brisbane', label: 'Brisbane (UTC+10)', description: 'Australian Eastern Standard Time' },
      { value: 'Australia/Perth', label: 'Perth (UTC+8)', description: 'Australian Western Standard Time' },
      { value: 'Australia/Adelaide', label: 'Adelaide (UTC+9:30/+10:30)', description: 'Australian Central Time' },
      { value: 'Pacific/Auckland', label: 'Auckland (UTC+12/+13)', description: 'New Zealand Standard/Daylight Time' },
      { value: 'Pacific/Fiji', label: 'Fiji (UTC+12/+13)', description: 'Fiji Standard/Summer Time' },
      { value: 'Pacific/Guam', label: 'Guam (UTC+10)', description: 'Chamorro Standard Time' },
      { value: 'Pacific/Tahiti', label: 'Tahiti (UTC-10)', description: 'Tahiti Time' }
    ]
  },
  {
    region: 'Atlantic & Other',
    timezones: [
      { value: 'Atlantic/Azores', label: 'Azores (UTC-1/+0)', description: 'Azores Standard/Summer Time' },
      { value: 'Atlantic/Cape_Verde', label: 'Cape Verde (UTC-1)', description: 'Cape Verde Time' },
      { value: 'Atlantic/Reykjavik', label: 'Reykjavik (UTC+0)', description: 'Greenwich Mean Time' },
      { value: 'Indian/Mauritius', label: 'Mauritius (UTC+4)', description: 'Mauritius Standard Time' },
      { value: 'Indian/Maldives', label: 'Maldives (UTC+5)', description: 'Maldives Time' },
      { value: 'Antarctica/McMurdo', label: 'McMurdo Station (UTC+12/+13)', description: 'New Zealand Time' }
    ]
  }
];

/**
 * Get flattened list of all timezones for simple dropdown
 */
export const getAllTimezones = () => {
  return WORLDWIDE_TIMEZONES.reduce((acc, region) => {
    return acc.concat(region.timezones);
  }, []);
};

/**
 * Get timezone by value
 */
export const getTimezoneByValue = (value) => {
  const allTimezones = getAllTimezones();
  return allTimezones.find(tz => tz.value === value);
};

/**
 * Format timezone for display
 */
export const formatTimezoneDisplay = (timezoneValue) => {
  const timezone = getTimezoneByValue(timezoneValue);
  return timezone ? timezone.label : timezoneValue || 'Not set';
};

/**
 * Check if timezone is valid
 */
export const isValidTimezone = (timezoneValue) => {
  if (!timezoneValue) return false;
  return getAllTimezones().some(tz => tz.value === timezoneValue);
};
